import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/menu/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-7bb667ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mobile-sidebar" }
const _hoisted_2 = { class: "mobile-navbar" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "ElrondBet Games Logo",
  class: "logo-image"
}, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "account-container"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "menu-toggle",
  type: "button",
  "data-bs-toggle": "offcanvas",
  "data-bs-target": "#offcanvas",
  "aria-controls": "offcanvas"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-list" })
], -1))
const _hoisted_6 = {
  id: "offcanvas",
  class: "offcanvas offcanvas-start",
  tabindex: "-1",
  "data-bs-scroll": "true",
  "data-bs-backdrop": "true"
}
const _hoisted_7 = { class: "offcanvas-header" }
const _hoisted_8 = { class: "offcanvas-title font-Baloo-Regular" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "close-button",
  "data-bs-dismiss": "offcanvas",
  "data-bs-target": "#offcanvas",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-lg" })
], -1))
const _hoisted_10 = { class: "offcanvas-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SidebarAccount = _resolveComponent("SidebarAccount")!
  const _component_SidebarCommon = _resolveComponent("SidebarCommon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: { name: _ctx.ROUTES.home },
        class: "navbar-logo"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["to"]),
      (_ctx.address)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_SidebarAccount)
          ]))
        : _createCommentVNode("", true),
      _hoisted_5
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("h5", _hoisted_8, _toDisplayString(_ctx.$t("app.menu")), 1),
        _hoisted_9
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_SidebarCommon)
      ])
    ])
  ]))
}